import { useSectionPageStyles } from "./section-page.styles";
import { SectionPageProps } from "../types/index";
import { cx } from "antd-style";

export const SectionPage = ({
  children,
  classNames,
  type = "default",
}: SectionPageProps) => {
  const { styles } = useSectionPageStyles();

  return (
    <div
      className={cx(
        styles.section,
        classNames?.section,
        type === "secondary" && styles.secondary,
      )}
    >
      <div className={cx(styles.body, classNames?.body)}>{children}</div>
    </div>
  );
};
